<template>
    <div>
        <div class="banner">
            <van-row>
                <van-col span="6" @click="back"><img class="back-icon" :src="require(`@/assets/theme/${theme}/status/01dailyActive/01back.svg`)"></van-col>
                <van-col span="12">
                    <div class="banner-title">确认添加好友</div>
                </van-col>
                <van-col span="6">
                </van-col>
            </van-row>
        </div>
        <div class="apply-box">
            <div class="apply-title">设置备注</div>
            <div class="apply-value">
                <div>
                    <van-field v-model="remark"/>
                </div>
<!--                <input class="a-input" v-model="remark">-->
                <img v-show="remark" @click="remark=''" class="apply-icon" src="@/assets/theme/light/share/09apply/01close.png">
            </div>
            <div class="apply-title">TA可以看</div>
            <div class="apply-value">
                <div>
                    <van-field v-model="privilege" readonly/>
                </div>
<!--                <input class="a-input" v-model="privilege" :disabled="true">-->
                <img class="apply-icon" @click="toPrivilege" src="@/assets/theme/light/desc/01prodInstructions/04to.svg">
            </div>
        </div>
        <div class="send-btn" @click="agreeApply"><span class="btn-text">确认发送</span></div>
    </div>
</template>

<script>
    import {Toast} from 'vant'
    export default {
        name: 'confirmAdd',
        data() {
            return {
                theme: 'light',
                user: {},
                applicationInformation: localStorage.hasOwnProperty("applicationInformation") ? localStorage.getItem("applicationInformation") : '我是',
                remark: localStorage.hasOwnProperty('remark') ? localStorage.getItem("remark") : '',
                privilege: '全部',
                statusPrivilege: localStorage.hasOwnProperty('statusPrivilege') ? localStorage.getItem("statusPrivilege") : 1,
                ecgPrivilege: localStorage.hasOwnProperty('ecgPrivilege') ? localStorage.getItem("ecgPrivilege") : 1,
                sportPrivilege: localStorage.hasOwnProperty('sportPrivilege') ? localStorage.getItem("sportPrivilege") : 1,
            }
        },
        mounted() {
            if (this.$route.query.theme) {
                this.theme = this.$route.query.theme
            }
            this.user = JSON.parse(localStorage.getItem("addUser"));
            if (this.statusPrivilege == 1 && this.ecgPrivilege == 1 && this.sportPrivilege == 1) {
                this.privilege = '全部';
            } else {
                this.privilege = '';
                if (this.statusPrivilege == 1) {
                    let p = this.privilege == '' ? '身体状态' : '、身体状态';
                    this.privilege += p;
                }
                if (this.sportPrivilege == 1) {
                    let p = this.privilege == '' ? '运动记录' : '、运动记录';
                    this.privilege += p;
                }
                if (this.ecgPrivilege == 1) {
                    let p = this.privilege == '' ? '心脏健康' : '、心脏健康';
                    this.privilege += p;
                }
            }
        },
        methods: {
            back() {
                localStorage.removeItem("applicationInformation");
                localStorage.removeItem("remark");
                this.$router.back();
            },
            agreeApply() {
                this.$api.share.agreeApply({
                    id: this.user.id,
                    statusPrivilege: this.statusPrivilege,
                    sportPrivilege: this.sportPrivilege,
                    ecgPrivilege: this.ecgPrivilege,
                    remark: this.remark,
                    applicationInformation: this.applicationInformation
                }).then(res => {
                    localStorage.setItem("statusPrivilege", '1');
                    localStorage.setItem("ecgPrivilege", '1');
                    localStorage.setItem("sportPrivilege", '1');
                    localStorage.removeItem("applicationInformation");
                    localStorage.removeItem("remark");
                    Toast('添加成功！');
                    // 返回首页
                    this.$router.push({
                        name: 'shareHomeLight',
                        query: {
                            theme: this.theme
                        }
                    })
                })
            },
            toPrivilege() {
                localStorage.setItem("applicationInformation", this.applicationInformation);
                localStorage.setItem("remark", this.remark);
                this.$router.push({
                    name: 'privilegeLight',
                    params: {
                        user: this.user
                    },
                    query: {
                        theme: this.theme
                    }
                })
            }
        }
    }
</script>

<style scoped>

    .apply-title {
        font-size: 13px;
        color: rgba(0,0,0,0.5);
        margin-top: 20px;
        margin-left: 25px;
        margin-bottom: 12px;
    }

    .apply-value {
        width: 345px;
        height: 56px;
        margin: 0 auto;
        background: var(--bg-color-2);
        opacity: 1;
        border-radius: 10px;
        position: relative;
    }

    /deep/ input {
        background-color: transparent;
        color: var(--text-color-1);
        font-size: 15px;
        caret-color: #00BD9B;
        border: none;
        line-height: 36px;
    }

    /deep/ input::-webkit-input-placeholder {
        color: var(--text-color-1);
        opacity: 0.6;
    }

    /deep/ input::-moz-placeholder {
        color: var(--text-color-1);
        opacity: 0.6;
    }

    /deep/ input:-moz-placeholder {
        color: var(--text-color-1);
        opacity: 0.6;
    }

    /deep/ input::-ms-input-placeholder {
        color: var(--text-color-1);
        opacity: 0.6;
    }

    .apply-icon {
        position: absolute;
        width: 22px;
        height: 22px;
        top: 17px;
        right: 12px;
    }

    .send-btn {
        width: 345px;
        height: 52px;
        border-radius: 13px 13px 13px 13px;
        border: 2px solid #404040;
        line-height: 52px;
        text-align: center;
        position: absolute;
        bottom: 34px;
        left: 15px;
        font-size: 17px;
    }

    .btn-text {
        color: var(--text-color-1);
    }

    /deep/ .van-cell {
        background-color: var(--bg-color-2) !important;
        border-radius: 10px;
        height: 56px;
    }
</style>



// WEBPACK FOOTER //
// src/views/shareLight/13confirmAdd.vue